import defaultValues from './default.json';
import type { LocalisationConfigWithLang } from '../types';

const config: LocalisationConfigWithLang = {
  ...defaultValues,
  'page.policies_specific_country.url': {
    en: '/p/england-policies-and-regulations',
    fr: '/p/politiques-et-reglementations-angleterre',
  },
};

export default config;
